import { render, staticRenderFns } from "./MailingSegmentsTable.vue?vue&type=template&id=74a815bb&"
import script from "./MailingSegmentsTable.vue?vue&type=script&lang=js&"
export * from "./MailingSegmentsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports